import { createAction } from 'redux-actions';

export const setMlsAccessModalAction = createAction('MODALS/SET_SHOW_MLS_ACCESS_MODAL');
export const setMlsAccessValue = createAction('MODALS/SET_MLS_ACCESS_VALUE');
